/**
 * @module events/hooks/stopImmediatePropagation
 */

/**
 * Stops immediately the event propagation
 * @param {Event} event
 */
export default (
  event
) => {
  event.stopImmediatePropagation()
}
